import { createAction, props } from '@ngrx/store';
import {
	Account,
	AccountSettings,
	NotificationSetting,
	Product,
	User,
	UserSettings,
	AddOnSubscription,
} from '@state/session/models';
import { IntegrationType } from 'cargo-chief-commons';

export interface LoginSetupPayload {
	user: User;
	account: Account;
	accountSettings: AccountSettings;
	userSettings: UserSettings;
	products: Array<Product>;
	notificationSettings: Array<NotificationSetting>;
	redirect: boolean;
	addOnSubscriptions: Array<AddOnSubscription>;
	activeIntegrations: Array<IntegrationType>;
}

export const SessionActions = {
	login: {
		submit: {
			start: createAction(
				'[Session] Login Submit Started',
				props<{ email: string; password: string; rememberMe: boolean }>()
			),
			success: createAction('[Session] Login Submit Success', props<{ payload: { user: User } }>()),
			failed: createAction(
				'[Session] Login Submit Failure',
				props<{ payload: { message: string } }>()
			),
		},
		setup: {
			start: createAction(
				'[Session] Login Setup Started',
				props<{ payload: { redirect: boolean } }>()
			),
			success: createAction(
				'[Session] Login Setup Success',
				props<{ payload: LoginSetupPayload }>()
			),
			failed: createAction(
				'[Session] Login Setup Failure',
				props<{ payload: { message: string } }>()
			),
		},
	},
	validate: {
		start: createAction(
			'[Session] Validation Started',
			props<{ payload: { redirect: boolean } }>()
		),
		success: createAction('[Session] Validation Success'),
		fail: createAction('[Session] Validation Failure'),
	},
	logout: {
		start: createAction('[Session] Logout Started'),
	},
	storage: {
		update: createAction('[Session] Storage Updated'),
	},
	cache: {
		update: createAction('[Session] Cache Updated'),
	},
};
